
    import "src/page/account/style.module.css?farm_css_modules";
    
    export default {"container": `container-ad91303d`,"text": `text-ad91303d`}
    